import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { OrderInvoiceDto, OrderInvoicesClient } from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";
import ms from "ms";
import { OrdersQueryKeys } from "@features/orders-features/hooks/OrdersQueryKeys";

type InvoicesArgs = {
  biOrderId: number | undefined;
  orderNumber: string | undefined;
  custPONumber: string | undefined;
};

export function useGetOrderInvoices({
  biOrderId,
  orderNumber,
  custPONumber,
}: InvoicesArgs): UseQueryResult<OrderInvoiceDto[], Error> {
  const api = useApi(OrderInvoicesClient);

  const enabled = !!biOrderId && !!orderNumber && !!custPONumber;

  const fetchOrderInvoices = async (): Promise<OrderInvoiceDto[]> => {
    if (!biOrderId || !orderNumber || !custPONumber) {
      throw new Error("GET: Invoices - Order identifiers are required");
    }
    return await api.getInvoicesByOrderIdentifiers(
      biOrderId,
      orderNumber,
      custPONumber
    );
  };

  return useQuery({
    queryKey: [OrdersQueryKeys.Invoices, biOrderId, orderNumber, custPONumber],
    queryFn: fetchOrderInvoices,
    enabled,
    staleTime: ms("15s"),
  });
}
